import { Dispatch, SetStateAction } from 'react';

import { numberToCurrency } from '@/utils/Formatter';
import { UseFormik } from '@/utils/Formik/types';

import { useGuestDamage } from '@/hooks/GuestDamage/useGuestDamage';

import FormButton from '@/components/FormButton/FormButton';
import { CopyLink } from '@/components/GuestDamage/components/CopyLink';
import ItemLossForm from '@/components/GuestDamage/components/Forms/ItemLossForm';

import {
  ButtonContainer,
  GridContainer,
  ItemLossFormContainer,
  ItemLossFormItem,
  LinkText,
} from './styles';

interface ItemLossFormViewProps {
  formik: UseFormik<any>;
  quantity: number;
  setQuantity: Dispatch<SetStateAction<number>>;
  isEditingForm: boolean;
  setIsEditingForm: Dispatch<SetStateAction<boolean>>;
}

const ItemLossFormView = ({
  formik,
  quantity,
  setQuantity,
  isEditingForm,
  setIsEditingForm,
}: ItemLossFormViewProps) => {
  const { selectedGuestDamage, handleOpenFile } = useGuestDamage();

  return (
    <>
      {isEditingForm ? (
        <ItemLossForm
          formik={formik}
          quantity={quantity}
          setQuantity={setQuantity}
          isEditingForm={isEditingForm}
        />
      ) : (
        <ItemLossFormContainer
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          key="ItemLossForm"
          transition={{
            duration: 0.4,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <GridContainer>
            <ItemLossFormItem>
              <h3>Classificação do dano</h3>
              <p>{selectedGuestDamage.item_type || '-'}</p>
            </ItemLossFormItem>
            <ItemLossFormItem>
              <h3>Qual item foi danificado ?</h3>
              <p>{selectedGuestDamage.item_name || '-'}</p>
            </ItemLossFormItem>
            <ItemLossFormItem>
              <h3>O que precisa ser feito?</h3>
              <p>{selectedGuestDamage.resolution || '-'}</p>
            </ItemLossFormItem>
            <ItemLossFormItem>
              <h3>Evidências</h3>
              {selectedGuestDamage.evidences && selectedGuestDamage?.evidences?.length > 0
                ? selectedGuestDamage.evidences?.map((evidence) => (
                    <LinkText
                      onClick={() =>
                        handleOpenFile(evidence.evidence?.url!, evidence.evidence?.name!)
                      }
                    >
                      {evidence.evidence?.name}
                    </LinkText>
                  ))
                : '-'}
            </ItemLossFormItem>
            <ItemLossFormItem>
              <h3>Valor</h3>
              <p>{numberToCurrency(selectedGuestDamage.item_price) || '-'}</p>
            </ItemLossFormItem>
            <ItemLossFormItem>
              <h3>Link do orçamento</h3>
              <CopyLink link={selectedGuestDamage.quotation_link} />
            </ItemLossFormItem>
            <ItemLossFormItem>
              <h3>Orçamento / Nota fiscal</h3>
              <LinkText
                onClick={() =>
                  handleOpenFile(
                    selectedGuestDamage.quotation_file?.url!,
                    selectedGuestDamage.quotation_file?.name!,
                  )
                }
              >
                {selectedGuestDamage.quotation_file?.name || '-'}
              </LinkText>
            </ItemLossFormItem>
            <ItemLossFormItem>
              <h3>Observações</h3>
              <p>{selectedGuestDamage.observation || '-'}</p>
            </ItemLossFormItem>
          </GridContainer>
          <ButtonContainer>
            <FormButton onClick={() => setIsEditingForm(true)}>Editar item</FormButton>
          </ButtonContainer>
        </ItemLossFormContainer>
      )}
    </>
  );
};

export default ItemLossFormView;
